import {
    container,
    title,
    main,
    mainRaised,
    mrAuto,
    whiteColor,
    mlAuto,
} from "assets/jss/material-kit-pro-react.js";

const contactUsPageStyle = {
    main,
    mainRaised,
    mrAuto,
    mlAuto,
    container: {
        ...container,
        zIndex: 2,
    },
    title: {
        ...title,
        "&, & + h4": {
            color: whiteColor,
        },
    },
    textCenter: {
        textAlign: "center",
    },
    block: {
        color: "inherit",
        padding: "0.9375rem",
        fontWeight: "500",
        fontSize: "12px",
        textTransform: "uppercase",
        borderRadius: "3px",
        textDecoration: "none",
        position: "relative",
        display: "block",
    },
    inlineBlock: {
        display: "inline-block",
        padding: "0px",
        width: "auto",
    },
    list: {
        marginBottom: "0",
        padding: "0",
        marginTop: "0",
    },
    left: {
        float: "left!important",
        display: "block",
    },
    right: {
        padding: "15px 0",
        margin: "0",
        float: "right",
    },
    icon: {
        width: "18px",
        height: "18px",
        top: "3px",
        position: "relative",
    },
    subHeader: {
        ...title,
        "&, & + h2": {
        },
        padding: "20px 0 10px 0", textAlign: "justify"
    },
    contactContent: {
        paddingBottom: "40px",
        paddingTop: "40px",
    },
};

export default contactUsPageStyle;
